<template>
  <md-app md-mode="fixed">
    <md-app-toolbar class="md-toolbar md-primary">
      <div class="md-toolbar-row">
        <div class="md-toolbar-section-start">
          <div class="md-layout md-gutter">
            <div class="md-layout-item md-size-100">
              <slot name="breadcrumb"></slot>
            </div>
            <div class="md-layout-item">
              <h3 class="md-title">{{serie.title}}</h3>
            </div>
          </div>
        </div>
      </div>
      <div class="md-toolbar-row">
        <md-tabs class="md-primary" md-sync-route>
          <md-tab md-label="Home" :to="`/admin/series/${serie.series_id}`" exact></md-tab>
          <md-tab md-label="Templates" :to="`/admin/series/${serie.series_id}/templates`"></md-tab>
          <md-tab md-label="Members" :to="`/admin/series/${serie.series_id}/members`"></md-tab>
        </md-tabs>
      </div>
    </md-app-toolbar>
    <md-app-content>
      <md-tabs id="series-tabs" md-sync-route>
        <md-tab id="serie-analytics" md-label="Home" :to="`/admin/series/${serie.series_id}`" exact>
          <md-card class="serie-info-card md-primary">
            <md-card-header>
              <h5 class="md-body-2 serie-info-header">Templates</h5>
            </md-card-header>
            <md-card-content>
              <div class="md-display-1 serie-info-content">{{ serie.templates | count }}</div>
            </md-card-content>
          </md-card>
          <md-card class="serie-info-card md-primary">
            <md-card-header>
              <h5 class="md-body-2 serie-info-header">Assigned</h5>
            </md-card-header>
            <md-card-content>
              <div class="md-display-1 serie-info-content">{{ serie.members | count }}</div>
            </md-card-content>
          </md-card>
          <md-card class="serie-info-card md-primary">
            <md-card-header>
              <h5 class="md-body-2 serie-info-header">Open Rate</h5>
            </md-card-header>
            <md-card-content>
              <div
                class="md-display-1 serie-info-content"
              >{{ serie.rate && serie.rate.open | count }}</div>
            </md-card-content>
          </md-card>
          <md-card class="serie-info-card md-primary">
            <md-card-header>
              <h5 class="md-body-2 serie-info-header">Reply Rate</h5>
            </md-card-header>
            <md-card-content>
              <div
                class="md-display-1 serie-info-content"
              >{{ serie.rate && serie.rate.reply | count }}</div>
            </md-card-content>
          </md-card>
        </md-tab>
        <md-tab
          id="serie-templates"
          md-label="Templates"
          :to="`/admin/series/${serie.series_id}/templates`"
        >
          <TemplateList
            :templates ="filteredTemplates"
            detailLink="/admin/templates"
            @create="createTemplate"
            @filter="filterTemplates"
          />
        </md-tab>
        <md-tab
          id="serie-members"
          md-label="Members"
          :to="`/admin/series/${serie.series_id}/members`"
        >
          <AssignmentList :assignments="serie.assignments" @add="showAssignmentDialog = true" />
        </md-tab>
      </md-tabs>
      <AssignmentDialog
        :show="showAssignmentDialog"
        @cancel="showAssignmentDialog = false"
        @save="addAssignment"
      />
    </md-app-content>
  </md-app>
</template>
<script>
import TemplateList from "@/components/TemplateList.vue";
import AssignmentList from "@/components/AssignmentList.vue";
import AssignmentDialog from "@/components/modals/AssignmentDialog.vue";
export default {
  name: "SeriesDetail",
  components: {
    TemplateList,
    AssignmentList,
    AssignmentDialog
  },
  props: {
    serie: Object
  },
  methods: {
    createTemplate: function(m) {
      this.$emit("addTemplate", m);
    },
    addAssignment: function(a) {
      this.$emit("addAssignment", a);
    },
    filterTemplates: function(search) {
      this.templateFilter = search;
    },
    filterAssignment: function(search) {
      this.assignmentFilter = search;
    }
  },
  data: function() {
    return {
      showAssignmentDialog: false,
      templateFilter: undefined,
      assignmentFilter: undefined
    };
  },
  computed: {
    filteredTemplates: function() {
      if (this.templateFilter) {
        return this.serie.templates.filter(
          m =>
            m.title.toLowerCase().indexOf(this.templateFilter.toLowerCase()) !=
            -1
        );
      } else {
        return this.serie.templates;
      }
    },
    filteredAssignments: function() {
      if (this.assignmentFilter) {
        return this.serie.assignments.filter(
          m =>
            (m.first_name + " " + m.last_name)
              .toLowerCase()
              .indexOf(this.assignmentFilter.toLowerCase()) != -1
        );
      } else {
        return this.serie.assignments;
      }
    }
  },
  filters: {
    count: function(value) {
      if (value) return value.length;
      else return 0;
    }
  }
};
</script>
<style lang="scss">
#series-tabs .md-tabs-navigation {
  display: none;
}
.serie-info-card {
  width: 125px;
  display: inline-block;
  vertical-align: top;
}
.serie-info-header {
  margin-top: 0px;
  text-align: center;
}
.serie-info-content {
  text-align: center;
}
.list-containers {
  margin-top: 15px;
  padding-left: 15px;
  padding-right: 15px;
}
</style>
